var exports = {
  "ki": "calendarIcon__jlRsRk",
  "$_": "breadcrumbItem__9k4LIU",
  "_C": "breadcrumbItemBold__DcBulm",
};

module.exports = exports;
